import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router";
import { addProcessData, getProcessById, updateProcessData } from "../services/processAPI";
import AppMenu from "../components/AppMenu";
import { title } from "../config";
import { Button, FormGroup, Label, Input } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getAllProcess } from '../services/processAPI';


export default function AddProcess() {
    const navigate = useNavigate();
    const { recordId } = useParams();
    const { state } = useLocation();
    const [formInput, setFormInput] = useState({});
    const [processFields, setProcessFields] = useState([]);
    const [processName, setProcessName] = useState("");
    const [buttonLabel, setBLabel] = useState("Add");

    useEffect(() => {
        if (recordId) {
            loadProcess(recordId);
        } else {
            initializeFields();
        }
    }, [recordId]);

    const process = getAllProcess()[0];
    const fields = [
        { name: "name", label: "Name", type: "text" },
        { name: "email", label: "Email", type: "checkbox" },
        { name: "birthdate", label: "Date of Birth", type: "date" },
        { name: "formVerified", label: "Form Verified", type: "checkbox" },
        { name: "successfullyDone", label: "Successfully Done", type: "checkbox" }
    ];
    const initializeFields = () => {
        // Define static fields here or fetch them from an API
        setProcessFields(fields);
        setFormInput(fields.reduce((acc, field) => ({ ...acc, [field.name]: field.type === 'checkbox' ? false : '' }), {}));
        setProcessName(state?.process?.processName); // Set default process name if needed
    };

    const loadProcess = async (id) => {
        let record = await getProcessById(id);
        setFormInput(record);
        setProcessFields(fields);
        setProcessName(record.processName);
        setBLabel("Update");
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormInput({
            ...formInput,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const formatDateToCustomFormat = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const strHours = String(hours).padStart(2, '0');

        return `${day}/${month}/${year} ${strHours}:${minutes}:${seconds} ${ampm}`;
    };

    const handleAddEditSubmit = async (e) => {
        // e.preventDefault();
        const currentDateTime = new Date().toISOString();
        const newItem = { ...formInput, lastUpdated: formatDateToCustomFormat(currentDateTime), processName: processName };
        if (formInput._id !== undefined) {
            const updatedData = await updateProcessData(newItem);
            // setUser(updatedData);
        } else {
            await addProcessData(newItem);
        }
        navigate("/process");
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: formInput,
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
            email: Yup.string().required("Email is required"),
            birthdate: Yup.string().required("Birthdate is required"),
            formVerified: Yup.string().required("Form Verification is required"),
            successfullyDone: Yup.string().required("Process status is required"),
        }),
        onSubmit: async (values) => {
            handleAddEditSubmit(values);
        },
    });
    const { handleSubmit } = validation;
    return (
        <div>
            <div className="px-2 sticky-header">
                <h3 className="m-0 p-2"> {title} | {buttonLabel} Process</h3>
                <AppMenu title="Add Process" />
            </div>
            <h4 className="m-0 p-2">{processName} </h4>
            <div className="p-0 m-0 px-2">
                <div className="card p-3">
                    {/* {processFields.map((field, index) => (
                        <FormGroup key={index}>
                            <Label for={field.name}>
                                <strong>{field.label}</strong>
                            </Label>
                            <Input
                                type={field.type}
                                name={field.name}
                                id={field.name}
                                value={formInput[field.name]}
                                checked={formInput[field.name]}
                                onChange={handleInputChange}
                                className='m-1'
                            />
                            {validation.touched[field.name] && validation.errors[field.name] && (
                                <div className="text-danger">
                                    {validation.errors[field.name]}
                                </div>
                            )}
                        </FormGroup>
                    ))} */}
                      {process.steps.map((step, index) => (
                        <FormGroup key={index}>
                            <Input
                                type={"checkbox"}
                                name={step}
                                id={step}
                                //value={formInput[step]}
                                //checked={formInput[step]}
                                onChange={handleInputChange}
                                className='m-1'
                            />
                            <Label for={index}>
                                <strong>{step}</strong>
                            </Label>

                            {/* {validation.touched[field.name] && validation.errors[field.name] && (
                                <div className="text-danger">
                                    {validation.errors[field.name]}
                                </div>
                            )} */}
                        </FormGroup>
                    ))} 

                    <div className="row justify-content-center">
                        <Button className="col-md-2 col-sm-6" type="submit" color="primary" onClick={handleSubmit}>Submit</Button>
                        &nbsp;&nbsp;
                        <Button className="col-md-2 col-sm-6" color="secondary" onClick={() => navigate("/process")}>Cancel</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
